// extracted by mini-css-extract-plugin
module.exports = {"backImg":"ReactLoaders_backImg__ezH2F","inline":"ReactLoaders_inline__L394L"};